import { render, staticRenderFns } from "./provinceCityAreaData.vue?vue&type=template&id=87104f3c&scoped=true&"
import script from "./provinceCityAreaData.vue?vue&type=script&lang=js&"
export * from "./provinceCityAreaData.vue?vue&type=script&lang=js&"
import style0 from "./provinceCityAreaData.vue?vue&type=style&index=0&id=87104f3c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87104f3c",
  null
  
)

export default component.exports